import * as React from "react";
import { Badge } from "components/bootstrap";
import usePermissions from "hooks/usePermissions";
import useNotificationBadgeCount from "components/notifications/hooks/useNotificationBadgeCount";
import Routes from "routing/Routes";
import StringUtils from "util/StringUtils";
import NavBadgeItem from "./NavBadgeItem";
const MAX_DISPLAYED_COUNT = 99;
const NotificationBadge = () => {
  const { isPermitted } = usePermissions();
  const enabled = isPermitted("notifications:read");
  const { data: count } = useNotificationBadgeCount({ enabled });
  if (!enabled) return null;
  const accessibleLabel = count > 0 ? `${count} unread system ${StringUtils.pluralize(count, "notification", "notifications")}` : "No unread system notifications";
  const displayedCount = count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : count;
  return /* @__PURE__ */ React.createElement(NavBadgeItem, { to: Routes.SYSTEM.NOTIFICATIONS }, /* @__PURE__ */ React.createElement(
    Badge,
    {
      "aria-label": accessibleLabel,
      color: "gray",
      "data-testid": "notification-badge",
      leftIcon: "notifications",
      title: accessibleLabel
    },
    count > 0 ? displayedCount : null
  ));
};
export default NotificationBadge;
